import type {VoronoiTextureDistance, VoronoiTextureFeature} from "#material/nodes/texture/tex-voronoi/types"
import type {VoronoiTextureNode} from "#material/cycles/types"

export const cyclesFeature = (feature?: VoronoiTextureFeature): VoronoiTextureNode["parameters"]["feature"] => {
    if (!feature) {
        return undefined
    }

    switch (feature) {
        case "F1":
            return "f1"
        case "F2":
            return "f2"
        case "SMOOTH_F1":
            return "smooth_f1"
        case "DISTANCE_TO_EDGE":
            return "distance_to_edge"
        case "N_SPHERE_RADIUS":
            return "n_sphere_radius"
    }
}

export const cyclesMetric = (distance?: VoronoiTextureDistance): VoronoiTextureNode["parameters"]["metric"] => {
    if (!distance) {
        return undefined
    }

    switch (distance) {
        case "EUCLIDEAN":
            return "euclidean"
        case "MANHATTAN":
            return "manhattan"
        case "CHEBYCHEV":
            return "chebyshev"
        case "MINKOWSKI":
            return "minkowski"
    }
}
